<template>
  <v-dialog
    max-width="700"
    :value="selectTimeDialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    @click:outside="closeSelectTimeDialog"
  >
    <v-card class="py-10 px-sm-7">
      <CloseDialogButton :close="closeSelectTimeDialog" />
      <Loader :loaded="!!storeInfo.serviceDays" />
      <EmptyState v-if="storeInfo.serviceDays && !storeInfo.serviceDays.length"
        >No {{ formatText(order.service) }} times available</EmptyState
      >
      <v-container v-else fluid>
        <v-row>
          <v-col cols="12">
            <div class="font-size-lg font-weight-semibold text-center">
              Select {{ formatText(order.service) }} Date & Time
            </div>
          </v-col>
        </v-row>
        <v-row no-gutters class="height-saver">
          <v-col class="text-center">
            <span
              v-if="order.selectedDate"
              class="font-size-lg-res text-center"
            >
              {{ order.selectedDate.display }}
              <span v-if="order.selectedTime.time">at</span>
              {{ order.selectedTime.display }}
            </span>
            <span v-else class="font-size-lg text-center">Please select</span>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="6">
            <div class="no-overflow" style="max-height: 364px">
              <v-btn-toggle
                class="d-flex flex-column"
                @change="(val) => upDateTime('selectedDate', val)"
                borderless
                tile
              >
                <v-btn
                  class="mb-1 text-capitalize"
                  :class="
                    order.selectedDate.iso === day.iso ? 'active-side-nav' : ''
                  "
                  v-for="day in storeInfo.serviceDays"
                  :key="day.iso"
                  :value="day"
                  >{{ day.display }}</v-btn
                >
              </v-btn-toggle>
            </div>
          </v-col>
          <v-col cols="6" v-if="hoursForSelectedDay">
            <div class="no-overflow" style="max-height: 364px">
              <v-btn-toggle
                class="d-flex flex-column"
                @change="(val) => upDateTime('selectedTime', val)"
                borderless
                tile
              >
                <v-btn
                  class="mb-1 text-capitalize"
                  :class="
                    order.selectedTime.time === selectedDay.time
                      ? 'active-side-nav'
                      : ''
                  "
                  v-for="selectedDay in hoursForSelectedDay"
                  :key="selectedDay.time"
                  :value="selectedDay"
                  >{{ selectedDay.display }}</v-btn
                >
              </v-btn-toggle>
            </div>
          </v-col>
          <v-col cols="6" v-else>
            <div
              class="
                align-center
                color-suva-grey
                d-flex
                font-size-lg
                justify-center
                text-center
              "
            >
              Choose a {{ formatText(order.service) }} date
            </div>
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-btn
            color="primary"
            height="48"
            width="180"
            rounded
            @click.stop="closeSelectTimeDialog"
          >
            <div class="font-size-md text-capitalize">done</div>
          </v-btn>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";
import EmptyState from "@/components/EmptyState.vue";
import Loader from "@/components/UI/Loader.vue";

export default {
  name: "SelectTimeDialog",
  components: { CloseDialogButton, EmptyState, Loader },
  computed: {
    ...mapState({
      order: (state) => state.orders.order,
      storeInfo: (state) => state.store.info,
    }),
  },
  methods: {
    formatText(service) {
      return service === "DELIVERY" ? "Delivery" : "Pickup";
    },
  },
  props: {
    closeSelectTimeDialog: Function,
    hoursForSelectedDay: Array,
    selectTimeDialog: Boolean,
    upDateTime: Function,
  },
};
</script>

<style scoped>
.v-btn:not(.v-btn--text:not().v-btn--outlined).v-btn--active:before {
  opacity: 0 !important;
}
.theme--light.v-btn--active:hover::before,
.theme--light.v-btn--active::before {
  opacity: 0 !important;
}
.active-side-nav {
  background-color: var(--v-primary-base) !important;
  color: var(--color-white) !important;
}

.height-saver {
  height: 33px;
}
</style>
